import Services1 from '../images/service1.jpg';
import Services2 from '../images/service2.jpg';
import Services3 from '../images/truck4a.jpg';
import Services4 from '../images/truck9a.jpg';

export default function Services(){
    return(
        <div className="pr-5 pl-5 pb-5">
            <h2 className="text-center pb-5 mt-5" style={{fontWeight:"600", fontSize:"40px"}}>We Offer Various Logistic Services</h2>            
            <div className="row">
                <div className='col-sm-3 mt-3'>
                    <div style={{border:"0px solid blue",boxShadow:"5px 5px 9px grey"}}>
                        <h4 className="text-center text-primary p-3">International Shipping</h4>
                        <img src={Services2} alt="3 keys cargo services" width="100%" />    
                        <p class="text-center p-3 bg-primary text-white">
                            Handling both air and sea freight services for international delivery
                        </p>
                    </div> 
                </div>

                <div className='col-sm-3 mt-3'>
                    <div style={{border:"0px solid blue",boxShadow:"5px 5px 9px grey"}}>
                        <h4 className="text-center text-primary p-3">Local Shipping</h4>
                        <img src={Services1} alt="3 keys cargo services" width="100%" />    
                        <p class="text-center p-3 bg-primary text-white">
                            Next-day delivery and timely deliver to any part of the country.
                        </p>
                    </div> 
                </div>

                <div className='col-sm-3 mt-3'>
                    <div style={{border:"0px solid blue",boxShadow:"5px 5px 9px grey"}}>
                        <h4 className="text-center text-primary p-3">Forwarding</h4>
                        <img src={Services3} alt="3 keys cargo services" width="100%" />    
                        <p class="text-center p-3 bg-primary text-white">
                            Customs handling, clearing of shipments and delivery.
                        </p>
                    </div> 
                </div>

                <div className='col-sm-3 mt-3'>
                    <div style={{border:"0px solid blue",boxShadow:"5px 5px 9px grey"}}>
                        <h4 className="text-center text-primary p-3">Packaging</h4>
                        <img src={Services4} alt="3 keys cargo services" width="100%" />    
                        <p class="text-center p-3 bg-primary text-white">
                            We handle giftbags, plastic sealables of various sizes.
                        </p>
                    </div> 
                </div>

            </div>
        </div>
    );
}